"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _commonReact = require("@devsta/common-react");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function AssetLoader(_ref) {
  var assetId = _ref.assetId;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "section__video-section__loading"
  }, /*#__PURE__*/_react.default.createElement("div", {
    key: "".concat(assetId, "-loading"),
    style: {
      width: '400px',
      height: '75px'
    }
  }, /*#__PURE__*/_react.default.createElement(_commonReact.ContentLoader, {
    height: "100",
    width: "400"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: "0",
    y: "0",
    rx: "5",
    ry: "5",
    width: "75",
    height: "75"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "85",
    y: "17",
    rx: "4",
    ry: "4",
    width: "300",
    height: "13"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "85",
    y: "40",
    rx: "3",
    ry: "3",
    width: "275",
    height: "10"
  }))));
}

var _default = (0, _react.memo)(AssetLoader);

exports.default = _default;